export class Option {
    constructor(p_value, p_label, p_order)
    {
        this.value = p_value;
        this.label = p_label;
        this.order = p_order;
    }
}